import service from '@/utils/request'
// @Summary 用户登录 获取动态路由
// @Produce  application/json
// @Param 可以什么都不填 调一下即可
// @Router /menu/getMenu [post]
// 获取充值订单
export const getRechargeList = (data) => {
  return service({
    url: '/uOrder/getRechargeList',
    method: 'post',
    data
  })
}

// 获取异常到账充值订单
export const getAbnormalRechargeList = (data) => {
  return service({
    url: '/uOrder/getAbnormalRechargeList',
    method: 'post',
    data
  })
}

// 获取提现订单
export const getWithdrawList = (data) => {
  return service({
    url: '/uOrder/getWithdrawList',
    method: 'post',
    data
  })
}

// 获取首充订单
export const getFirstApprovalList = (data) => {
  return service({
    url: '/uOrder/getFirstApprovalList',
    method: 'post',
    data
  })
}

// 获取待审核订单
export const getWaitApprovalList = (data) => {
  return service({
    url: '/uOrder/getWaitApprovalList',
    method: 'post',
    data
  })
}

// 审核订单
export const auditOrder = (data) => {
  return service({
    url: '/uOrder/auditOrder',
    method: 'post',
    data
  })
}

// 获取邀请详情 （接口不存在）
export const getInviteDetail = (data) => {
  return service({
    url: '/uOrder/getInviteDetail',
    method: 'post',
    data
  })
}

// 手动回调
export const manualCallback = (data) => {
  return service({
    url: '/uPay/manualCallback',
    method: 'post',
    data
  })
}

// 获取支付方式
export const getPayWayList = (data) => {
  return service({
    url: '/uPay/getPayWayList',
    method: 'post',
    data
  })
}

// 修改订单备注
export const updateOrderRemark = (data) => {
  return service({
    url: '/uOrder/updateOrderRemark',
    method: 'post',
    data
  })
}

// 提现统计
export const getWithdrawSTA = (data) => {
  return service({
    url: '/uPay/getWithdrawSTA',
    method: 'post',
    data
  })
}

// 充值统计
export const getRechargeSTA = (data) => {
  return service({
    url: '/uPay/getRechargeSTA',
    method: 'post',
    data
  })
}

// 获取重置允许渠道
export const getWithdrawApprovalOption = (data) => {
  return service({
    url: '/uOrder/getWithdrawApprovalOption',
    method: 'post',
    data
  })
}

// 提现审核通过
export const withdrawApprovalPass = (data) => {
  return service({
    url: '/uOrder/withdrawApprovalPass',
    method: 'post',
    data
  })
}

// 拒绝提现
export const withdrawApprovalReject = (data) => {
  return service({
    url: '/uOrder/withdrawApprovalReject',
    method: 'post',
    data
  })
}

// 银行列表
export const getBankList = (data) => {
  return service({
    url: '/uPay/getBankList',
    method: 'post',
    data
  })
}

// 获取用户反馈列表
export const getUserFeedbackList = (data) => {
  return service({
    url: '/uOrder/getUserFeedbackList',
    method: 'post',
    data
  })
}

// 异常补单
export const makeUpOrder = (data) => {
  return service({
    url: '/uPay/makeUpOrder',
    method: 'post',
    data
  })
}

// 处理异常到账
export const handleAbnormalArrive = (data) => {
  return service({
    url: '/uPay/handleAbnormalArrive',
    method: 'post',
    data
  })
}

// 拒绝异常到账
export const rejectAbnormalArrive = (data) => {
  return service({
    url: '/uPay/rejectAbnormalArrive',
    method: 'post',
    data
  })
}

// 导出充值订单Excel
export const exportRechargeList = (data) => {
  return service({
    url: '/uOrder/exportRechargeList',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 获取待处理订单列表（用于音频提醒）
export const getWaitApprovalOrders = (data) => {
  return service({
    url: '/uSite/getWaitApprovalOrders',
    method: 'post',
    data
  })
}
